/**
 * Helpers couleur hex partagés entre les modes popup / badge du SDK.
 */

import type { RintintinBookingInitOptions } from './types';

/** Couleur d'accent Rintintin par défaut (alignée embed + backoffice). */
export const DEFAULT_ACCENT_COLOR = '#a5765c';

/** Normalise une couleur hex (accepte avec/sans #). Retourne `null` si invalide. */
export function normalizeHexColor(raw: string | undefined): string | null {
  if (!raw) return null;
  const cleaned = raw.replace(/^#/, '').trim();
  if (/^[0-9A-Fa-f]{6}$/.test(cleaned)) return `#${cleaned.toLowerCase()}`;
  return null;
}

/**
 * Résout la couleur d'accent du widget :
 * `opts.accent` si valide, sinon `fallback` (défaut marque).
 */
export function resolveAccentColor(
  opts: Pick<RintintinBookingInitOptions, 'accent'>,
  fallback: string = DEFAULT_ACCENT_COLOR
): string {
  return normalizeHexColor(opts.accent) || fallback;
}

/**
 * Résout la couleur de fond du badge :
 *  1. `opts.badgeColor` si valide
 *  2. sinon `opts.accent` si valide
 *  3. sinon couleur par défaut
 */
export function resolveBadgeColor(opts: RintintinBookingInitOptions): string {
  return (
    normalizeHexColor(opts.badgeColor) ||
    normalizeHexColor(opts.accent) ||
    DEFAULT_ACCENT_COLOR
  );
}

/** Applique accent + variable CSS focus sur un bouton SDK (trigger popup). */
export function applyTriggerAccentStyles(
  button: HTMLButtonElement,
  opts: Pick<RintintinBookingInitOptions, 'accent'>
): void {
  const color = resolveAccentColor(opts);
  button.style.background = color;
  button.style.setProperty('--rtt-trigger-accent', color);
}
